import { useCallback } from "react";

import { formatDate } from "@/lib/dayjs/format-date";

import type { ViewData } from "../../../../model/type";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const downloadCSV = (csv: any, fileName: string) => {
	const blob = new Blob([csv], { type: "text/csv" });
	const link = document.createElement("a");
	link.href = window.URL.createObjectURL(blob);
	link.download = fileName;
	link.click();
};

const FORMAT_DATE_TEMPLATE = "YYYY-MM-DD";

export const useDownloadCSV = () => {
	/**
	 * 収支リストに関するCSVをダウンロードする
	 * WEB上でのダウンロードまでを担当している（サーバサイドだと実行できない）
	 *
	 * 基本的には旧管理画面（Nuxt v2）からコードをそのまま持ってきている
	 */
	const downloadECReceiptCSV = useCallback((rows: ViewData["searchResultTableData"]["rows"]) => {
		const headers = [
			"レシートID",
			"名前",
			"名前（カナ）",
			"購入日",
			"合計料金",
			"電話番号",
			"メールアドレス",
			"郵便番号",
			"住所",
			"購入商品",
		] as const;

		const data = rows.map((receipt) => {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			const csvArray: any[] = new Array<string>(headers.length - 1).map((_) => "");
			csvArray[headers.indexOf("レシートID")] = `'${receipt.receiptID}'`;
			csvArray[headers.indexOf("名前")] = receipt.guestName;
			csvArray[headers.indexOf("名前（カナ）")] = receipt.guestNameKana || "";
			csvArray[headers.indexOf("購入日")] = formatDate(receipt.purchasedDate, FORMAT_DATE_TEMPLATE);
			csvArray[headers.indexOf("合計料金")] = receipt.totalGuestCharge;
			csvArray[headers.indexOf("電話番号")] = `'${receipt.guestTel}'`;
			csvArray[headers.indexOf("メールアドレス")] = receipt.guestEmail;
			csvArray[headers.indexOf("郵便番号")] = `'${receipt.guestPostalCode}'`;
			csvArray[headers.indexOf("住所")] = receipt.guestAddress;
			csvArray[headers.indexOf("購入商品")] = receipt.purchasedItems
				.map((item) => item.name + `(${item.amount}個)`)
				.join("cellOpening")
				.replace(/cellOpening/g, "\n");
			return csvArray.map((item) => `"${item}"`).join(",");
		});
		const header = `\ufeff${headers.join(",")}`;
		const csv = [header, ...data].join("\n");
		downloadCSV(csv, `CHILLNN_EC情報_${new Date().getTime()}.csv`);
	}, []);

	return {
		downloadECReceiptCSV,
	};
};
